module.exports = __webpack_public_path__ + "static/pitchi2x-0b557e7d9fbbbd8331420a3eef658b5d.jpg";